<template>
  <q-form ref="editForm">
    <c-card title="기본정보" class="cardClassDetailForm">
      <template slot="card-button">
        <q-btn-group outline >
          <c-btn
            :url="saveUrl"
            v-if="editable"
            :isSubmit="isSave"
            :param="data"
            :mappingType="saveType"
            label="저장"
            icon="save"
            @beforeAction="saveMst"
            @btnCallback="saveCallback" 
          />
        </q-btn-group>
      </template>
      <template slot="card-detail">
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
          <c-text
            required
            :editable="editable"
            label="설치장소"
            name="envDangerArea"
            v-model="data.envDangerArea">
          </c-text>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
          <c-text
            required
            :editable="editable"
            label="품명"
            name="envDangerMstName"
            v-model="data.envDangerMstName">
          </c-text>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
          <c-text
            :editable="editable"
            label="지정수량"
            name="envDangerCount"
            v-model="data.envDangerCount">
          </c-text>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
          <c-multi-field
            :editable="editable"
            :data="data"
            label="안전관리자"
            type="user"
            name="envDangerManageUserId"
            v-model="data.envDangerManageUserId">
          </c-multi-field>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
          <c-multi-field
            :editable="editable"
            :data="data"
            label="담당자"
            type="user"
            name="envDangerUserId"
            v-model="data.envDangerUserId">
          </c-multi-field>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
          <c-multi-field
            :editable="editable"
            :data="data"
            label="안전대리자"
            type="user"
            name="envDangerSafetyUserId"
            v-model="data.envDangerSafetyUserId">
          </c-multi-field>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
          <c-text
            :editable="editable"
            label="주용도"
            name="envDangerMainUse"
            v-model="data.envDangerMainUse">
          </c-text>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
          <c-plant 
            required
            :editable="editable" 
            type="edit" 
            name="plantCd" 
            v-model="data.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
          <c-checkbox
            :editable="editable"
            :isFlag="true"
            label="사용여부"
            name="useFlag"
            v-model="data.useFlag"
          />
        </div>
      </template>
    </c-card>
    <div class="col-lg-12 col-md-12 col-sm-12">
      <c-table
        ref="table1"
        title="저장소구분/저장품목"
        :columns="grid1.columns"
        gridHeight="200px"
        :data="data.typeList"
        :filtering="false"
        :columnSetting="false"
        :usePaging="false"
        noDataLabel="저장소구분/저장품목을 추가하세요."
        :hideBottom="true"
        :editable="editable"
        rowKey="envDangerMstTypeId"
        selection="multiple"
      >
        <template slot="table-button">
          <q-btn-group outline>
            <c-btn v-if="editable" :showLoading="false" label="추가" icon="add" @btnClicked="addType" />
            <c-btn v-if="editable && data.typeList.length > 0" :showLoading="false" label="제외" icon="remove" @btnClicked="removeType" />
          </q-btn-group>
        </template>
      </c-table>
    </div>
    <div class="col-lg-12 col-md-12 col-sm-12">
      <c-table
        ref="table2"
        title="점검항목 목록"
        :columns="grid2.columns"
        gridHeight="400px"
        :data="data.itemList"
        :filtering="false"
        :columnSetting="false"
        :usePaging="false"
        noDataLabel="점검항목을 추가하세요."
        :hideBottom="true"
        :editable="editable"
        rowKey="envDangerMstItemId"
        selection="multiple"
      >
        <template slot="table-button">
          <q-btn-group outline>
            <c-btn v-if="editable" :showLoading="false" label="추가" icon="add" @btnClicked="addItem" />
            <c-btn v-if="editable && data.itemList.length > 0" :showLoading="false"  label="제외" icon="remove" @btnClicked="removeItem" />
          </q-btn-group>
        </template>
      </c-table>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </q-form>
</template>

<script>
import { uid } from 'quasar'
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'danger-master-detail',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        envDangerMstId: '',
      }),
    },
  },
  data() {
    return {
      editable: true,
      searchUrl: '',
      grid1: {
        columns: [
          {
            required: true,
            name: 'envDangerTypeName',
            field: 'envDangerTypeName',
            label: '저장소구분/저장품목',
            style: 'width:200px',
            align: 'left',
            type: 'text',
            sortable: false,
          },
          {
            required: true,
            name: 'calcuMethod',
            field: 'calcuMethod',
            label: '지정수량 계산방식(숫자를 입력하세요.)',
            style: 'width:200px',
            align: 'left',
            type: 'number',
            sortable: false,
          },
        ],
        height: '300px'
      },
      grid2: {
        columns: [
          {
            required: true,
            name: 'envDangerItemName',
            field: 'envDangerItemName',
            label: '점검항목',
            style: 'width:300px',
            align: 'left',
            type: 'text',
            sortable: false,
          },
          {
            name: 'sortOrder',
            field: 'sortOrder',
            label: '순번',
            style: 'width:40px',
            align: 'left',
            type: 'number',
            sortable: false,
          },
        ],
        height: '300px'
      },
      data: {
        envDangerMstId: '',
        plantCd: '',
        envDangerArea: '',
        envDangerManageUserId: '',
        envDangerMstName: '',
        envDangerUserId: '',
        envDangerSafetyUserId: '',
        envDangerCount: '',
        envDangerMainUse: '',
        useFlag: 'Y',
        
        typeList: [],
        deleteTypeList: [],

        itemList: [],
        deleteItemList: [],
      },
      useFlagItems: [
        { code: 'Y', codeName: '사용' },
        { code: 'N', codeName: '미사용' },
      ],
      saveUrl: 'transactionConfig.env.danger.master.insert.url',
      saveType: 'POST',
      isSave: false,
      getUrl: '',
      insertUrl: '',
      deleteUrl: '',
      updateUrl: '',
      updateMode: false,
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        width: '90%',
        top: '10px',
        param: {},
        closeCallback: null,
      },
    };
  },
  computed: {
  },
  watch: {
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.getUrl = selectConfig.env.danger.master.get.url;
      this.insertUrl = transactionConfig.env.danger.master.insert.url;
      this.updateUrl = transactionConfig.env.danger.master.update.url;
      // list setting
      this.getDetail();
    },
    getDetail() {
      if (this.popupParam.envDangerMstId) {
        this.$http.url = this.$format(this.getUrl, this.popupParam.envDangerMstId);
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          this.data = this.$_.clone(_result.data);
        },);
      }
    },
    saveMst() {
      if (this.data.envDangerMstId) {
        this.saveUrl = this.updateUrl;
        this.saveType = 'PUT';
      } else {
        this.saveUrl = this.insertUrl;
        this.saveType = 'POST';
      }
      this.$refs['editForm'].validate().then(_result => {
        if (_result) { 
          if (this.$comm.validTable(this.grid1.columns, this.data.typeList)) {
            if (this.$comm.validTable(this.grid2.columns, this.data.itemList)) {
              window.getApp.$emit('CONFIRM', {
                title: '확인',
                message: '저장하시겠습니까?',
                // TODO : 필요시 추가하세요.
                type: 'info', // success / info / warning / error
                // 확인 callback 함수
                confirmCallback: () => {
                  this.data.regUserId = this.$store.getters.user.userId
                  this.data.chgUserId = this.$store.getters.user.userId
                  
                  this.isSave = !this.isSave;
                },
                // 취소 callback 함수
                cancelCallback: () => {
                },
              });
            } else {
              window.getApp.$emit('APP_VALID_ERROR');
            }
          }
        }
      });
    },
    saveCallback(result) {
      this.popupParam.envDangerMstId = result.data
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.getDetail();
    },
    addType() {
      this.data.typeList.push({
        envDangerMstId: this.popupParam.envDangerMstId,
        envDangerMstTypeId: uid(),
        envDangerTypeName: '',
        calcuMethod: '',
        regUserId: this.$store.getters.user.userId,
        chgUserId: this.$store.getters.user.userId,
        editFlag: 'C'
      })
    },
    removeType() {
      let selectData = this.$refs['table1'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '하나 이상 선택하세요.', // 하나 이상 선택하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        this.$_.forEach(selectData, item => {
          if (!this.data.deleteTypeList) {
            this.data.deleteTypeList = []
          }
          if (this.$_.findIndex(this.data.deleteTypeList, { envDangerMstTypeId: item.envDangerMstTypeId }) === -1
            && item.editFlag !== 'C') {
              this.data.deleteTypeList.push(item)
          }
          this.data.typeList = this.$_.reject(this.data.typeList, item)
        })
      }
    },
    addItem() {
      this.data.itemList.push({
        envDangerMstId: this.popupParam.envDangerMstId,
        envDangerMstItemId: uid(),
        envDangerItemName: '',
        sortOrder: this.data.itemList.length + 1,
        regUserId: this.$store.getters.user.userId,
        chgUserId: this.$store.getters.user.userId,
        editFlag: 'C'
      })
    },
    removeItem() {
      let selectData = this.$refs['table2'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '하나 이상 선택하세요.', // 하나 이상 선택하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        this.$_.forEach(selectData, item => {
          if (!this.data.deleteItemList) {
            this.data.deleteItemList = []
          }
          if (this.$_.findIndex(this.data.deleteItemList, { envDangerMstItemId: item.envDangerMstItemId }) === -1
            && item.editFlag !== 'C') {
              this.data.deleteItemList.push(item)
          }
          this.data.itemList = this.$_.reject(this.data.itemList, item)
        })
      }
    },
  }
};
</script>
